import React from 'react';
import '../../assets/css/Blog.css'; // adjusted path
import heroImage from '../../assets/img/logo/comparedly-logo.png'; // adjusted path

const BlogBottomCTA = () => {
    return (
        <div className="blog-bottom-cta-section">
            <div className="cta-content-wrapper">
                <div className="cta-image-col">
                    {/* CSS-only Laptop Frame */}
                    <div className="laptop-mockup">
                        <div className="laptop-screen">
                            <img
                                src="/content/blog/images/platform-scout-preview.png"
                                alt="Comparedly Platform Scout"
                                className="cta-dashboard-img"
                            />
                        </div>
                        <div className="laptop-base"></div>
                    </div>
                </div>
                <div className="cta-text-col">
                    <div className="cta-brand-header">
                        <img src={heroImage} alt="Comparedly" className="cta-logo-icon" />
                        <span className="cta-brand-name">COMPAREDLY</span>
                    </div>
                    <h2 className="cta-main-headline">
                        Unlock competitive insights with hassle-free benchmarking
                    </h2>
                    <p className="cta-subtext">
                        Comparedly empowers you to track performance, analyze sentiment, and outpace your competitors across Facebook, Instagram, and YouTube. Get the clarity you need to grow your brand, without the complexity.
                    </p>
                    <button
                        className="btn-primary cta-action-btn"
                        onClick={() => window.location.href = `${process.env.REACT_APP_URL}/auth/register`}
                    >
                        Start Your Free Trial
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BlogBottomCTA;
